import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.75 8.89388V8.39388H3.25V8.89388H3.75ZM16.25 8.89388H16.75V8.39388H16.25V8.89388ZM16.25 18.8939V19.3939H16.75V18.8939H16.25ZM3.75 18.8939H3.25V19.3939H3.75V18.8939ZM12.4167 8.89388C12.4167 9.17002 12.6405 9.39388 12.9167 9.39388C13.1928 9.39388 13.4167 9.17002 13.4167 8.89388H12.4167ZM6.58333 8.89388C6.58333 9.17002 6.80719 9.39388 7.08333 9.39388C7.35948 9.39388 7.58333 9.17002 7.58333 8.89388H6.58333ZM10.5 12.6439V12.1439H9.5V12.6439H10.5ZM9.5 15.1439V15.6439H10.5V15.1439H9.5ZM3.75 9.39388H16.25V8.39388H3.75V9.39388ZM15.75 8.89388V18.8939H16.75V8.89388H15.75ZM16.25 18.3939H3.75V19.3939H16.25V18.3939ZM4.25 18.8939V8.89388H3.25V18.8939H4.25ZM12.4167 5.97721V8.89388H13.4167V5.97721H12.4167ZM7.58333 8.89388V5.97721H6.58333V8.89388H7.58333ZM10 3.56055C11.3347 3.56055 12.4167 4.64253 12.4167 5.97721H13.4167C13.4167 4.09024 11.887 2.56055 10 2.56055V3.56055ZM10 2.56055C8.11303 2.56055 6.58333 4.09024 6.58333 5.97721H7.58333C7.58333 4.64253 8.66531 3.56055 10 3.56055V2.56055ZM9.5 12.6439V15.1439H10.5V12.6439H9.5Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }